export default class FormsMitgliedschaftsformular {
  constructor(element = null) {
    if (!element) {
      return
    }
    this.element = element
    this.init()
  }

  init() {
    console.log(this.element)
    this.allRows = Array.from(this.element.querySelectorAll('.freeform-row, [data-freeform-controls]'))

    // Create CTA button element
    this.ctaButton = document.createElement('div')
    this.ctaButton.className = 'cta-container form-hidden'
    this.ctaButton.innerHTML = '<a href="#" class="btn btn-cta primary"><span>Bitte melden Sie sich über die FSP an</span></a>'
    this.element.appendChild(this.ctaButton)

    // Set initial state and then add the initialized class to enable transitions
    this.allRows.forEach((row, index) => {
      if (index > 0) {
        row.classList.add('form-hidden')
      }
    })

    // Add initialized class to enable transitions
    setTimeout(() => {
      this.element.classList.add('form-initialized')
    }, 50)

    // Add event listeners to first row radio buttons
    const firstRadio = this.allRows[0].querySelectorAll('input[type="radio"]')
    firstRadio.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.evaluateRadios()
      })
    })

    // Add event listeners to second row radio buttons (only once)
    const secondRadio = this.allRows[1].querySelectorAll('input[type="radio"]')
    secondRadio.forEach((radio) => {
      radio.addEventListener('change', () => {
        this.evaluateRadios()
      })
    })
  }

  evaluateRadios() {
    const firstRadios = Array.from(this.allRows[0].querySelectorAll('input[type="radio"]'))
    const firstSelectedRadio = firstRadios.find(radio => radio.checked)

    const secondRadios = Array.from(this.allRows[1].querySelectorAll('input[type="radio"]'))
    const secondSelectedRadio = secondRadios.find(radio => radio.checked)

    if (firstSelectedRadio && firstSelectedRadio.value === 'Psycholog:in') {
      this.allRows[1].classList.remove('form-hidden')
    }
    else {
      this.allRows[1].classList.add('form-hidden')
      this.allRows[1].querySelectorAll('input[type="radio"]').forEach((input) => {
        input.checked = false
      })
    }

    if (firstSelectedRadio && (
      firstSelectedRadio.value !== 'Psycholog:in'
      || (secondSelectedRadio && secondSelectedRadio.id === 'form-input-ichBin2-2')
    )) {
      this.toggleMainForm(true)
    }
    else {
      this.toggleMainForm(false)
    }
  }

  toggleMainForm(show) {
    // Show/hide the main form rows with animation
    this.allRows.forEach((row, index) => {
      if (index > 1) {
        if (show) {
          row.classList.remove('form-hidden')
        }
        else {
          row.classList.add('form-hidden')
        }
      }
    })

    // Show CTA button only when the main form is hidden AND both radios are selected correctly
    const firstRadio = Array.from(this.allRows[0].querySelectorAll('input[type="radio"]')).find(radio => radio.checked)
    const secondRadio = Array.from(this.allRows[1].querySelectorAll('input[type="radio"]')).find(radio => radio.checked)

    const shouldShowCta = !show && firstRadio && secondRadio && firstRadio.value === 'Psycholog:in' && secondRadio.id !== 'form-input-ichBin2-2'

    if (shouldShowCta) {
      this.ctaButton.classList.remove('form-hidden')
    }
    else {
      this.ctaButton.classList.add('form-hidden')
    }
  }
}
